import { render } from "./organisation-details-block.vue?vue&type=template&id=6871c556&ts=true"
import script from "./organisation-details-block.ts?vue&type=script&lang=ts&external"
export * from "./organisation-details-block.ts?vue&type=script&lang=ts&external"

import "./organisation-details-block.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__